// API Configuration – works in local dev (CRA proxy) and production (nginx /api)
const getApiUrl = () => {
  const envUrl = process.env.REACT_APP_API_URL?.trim();
  if (envUrl) {
    return envUrl.replace(/\/$/, '');
  }

  if (typeof window === 'undefined') {
    return '/api';
  }

  const { hostname, protocol, port } = window.location;

  // Local network – backend on port 5001 of same machine
  if (/^192\.168\.\d+\.\d+$/.test(hostname) || /^10\.\d+\.\d+\.\d+$/.test(hostname)) {
    return `${protocol}//${hostname}:5001/api`;
  }

  const isLocalhost = hostname === 'localhost' || hostname === '127.0.0.1';

  // CRA dev server – package.json "proxy" forwards /api → :5001 (any dev port)
  if (isLocalhost && process.env.NODE_ENV === 'development') {
    return '/api';
  }

  if (isLocalhost) {
    return 'http://localhost:5001/api';
  }

  // Production VPS – same-origin reverse proxy (nginx: location /api → gunicorn)
  const hostWithPort = port && port !== '80' && port !== '443'
    ? `${hostname}:${port}`
    : hostname;
  return `${protocol}//${hostWithPort}/api`;
};

export const API_BASE_URL = getApiUrl();

/** Human-readable backend hint for error messages */
export const getApiServerHint = () => {
  if (API_BASE_URL.startsWith('/')) {
    return 'Ensure the backend is running and the dev proxy (or nginx /api) is configured.';
  }
  return API_BASE_URL.replace(/\/api\/?$/, '') || API_BASE_URL;
};

export default API_BASE_URL;
